import { IconDownload, IconDotsVertical, IconPlus } from "@tabler/icons-react";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ListView from "../../../components/common/ListView";
import NormalSearch from "../../../components/common/NormalSearch";
import { useState, useRef, useEffect } from "react";
import CommonModal from "../../../components/common/CommonModal";
import CreateTicketModal from "./CreateTicketModal";

const TicketData = [
  {
    id: 1,
    ticketID: "AB-54321 ",
    subject: "Payment issue",
    email: "sarah@example.com",
    dateTime: "01-Jun-25, 6:30 PM",
    status: "Closed",
    active: false,
  },
  {
    id: 2,
    ticketID: "AB-54321 ",
    subject: "Payment issue",
    email: "sarah@example.com",
    dateTime: "01-Jun-25, 6:30 PM",
    status: "Closed",
    active: false,
  },
  {
    id: 3,
    ticketID: "AB-54321 ",
    subject: "Payment issue",
    email: "sarah@example.com",
    dateTime: "01-Jun-25, 6:30 PM",
    status: "Closed",
    active: false,
  },
  {
    id: 4,
    ticketID: "AB-54321 ",
    subject: "Payment issue",
    email: "sarah@example.com",
    dateTime: "01-Jun-25, 6:30 PM",
    status: "Open",
    active: false,
  },
  {
    id: 5,
    ticketID: "AB-54321 ",
    subject: "Payment issue",
    email: "sarah@example.com",
    dateTime: "01-Jun-25, 6:30 PM",
    status: "Progress",
    active: false,
  },
];
export default function TicketsTab() {
  const [openShelve, setOpenShelve] = useState<boolean>(false);
  const openShelveToggleModal = () => {
    setOpenShelve(!openShelve);
  };

  const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(
    null
  );
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpenDropdownIndex(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  return (
    <div>
      <div>
        <div className="flex items-center">
          <div className=" bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[40px] ">
            <h1 className="text-xl text-[#212121] tracking-[-0.5px] font-medium">
              Tickets Lists
            </h1>
            <div className="flex items-center gap-2">
              <ColumnsFilter columnsData={[]} />
              <DropdownFilter filterheadings={[]} />
              <NormalSearch />
            </div>
          </div>
          <div className="relative ml-5">
            <div className=" flex items-center gap-2 justify-end rounded-full">
              <button
                // onClick={handleDownloadXLSX}
                className="flex items-center gap-1 p-2.5 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
              >
                <IconDownload stroke={1.5} size={24} />
              </button>

              <div
                className="relative inline-block text-left"
                ref={dropdownRef}
              >
                <button
                  onClick={openShelveToggleModal}
                  className="flex items-center gap-1  p-2.5 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
                >
                  <IconPlus stroke={1.5} size={24} />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className=" bg-[#F7F6F2] rounded-r-3xl rounded-b-3xl">
          {" "}
          <ListView
            data={TicketData}
            onRowClick={(client) => console.log("Clicked:", client)}
            columns={[
              { label: "S/N", render: (_, i) => i + 1 },
              {
                label: "Ticket ID",
                render: (c) => c.ticketID,
              },
              {
                label: "Subject",
                render: (c) => c.subject,
              },
              {
                label: "Email",
                render: (c) => c.email,
              },
              {
                label: "Date & Time",
                render: (c) => c.dateTime,
              },
              {
                label: "Status",
                render: (c) => {
                  let statusClasses = "";

                  if (c.status === "Progress") {
                    statusClasses = "bg-[#FCB910]/10 text-[#FCB910]";
                  } else if (c.status === "Closed") {
                    statusClasses = "bg-[#CDF3E5] text-[#43A581]";
                  } else if (c.status === "Open") {
                    statusClasses = "bg-[#FF4848]/10 text-[#FF4848]";
                  }

                  return (
                    <div className="flex justify-center">
                      <span
                        className={`rounded-full w-20 px-2 py-1 text-center inline-block ${statusClasses}`}
                      >
                        {c.status}
                      </span>
                    </div>
                  );
                },
              },
              {
                label: "Actions",
                render: (c: any) => (
                  <div className="relative flex items-center justify-center">
                    <button
                      onClick={() =>
                        setOpenDropdownIndex(openDropdownIndex === c ? null : c)
                      }
                      className="p-2 border rounded-full bg-[#F7F6F2]"
                    >
                      <IconDotsVertical size={20} />
                    </button>

                    {openDropdownIndex === c && (
                      <div
                        ref={dropdownRef}
                        className="absolute bg-[#F7F6F2] divide-y divide-[#979797]/50 right-24 -top-2 z-50 mt-2 w-32 rounded-xl shadow-lg overflow-hidden"
                      >
                        <div className="px-4 py-2 text-[#404040] hover:bg-[#FBD037]/10 cursor-pointer">
                          View Details
                        </div>
                        <div
                          onClick={openShelveToggleModal}
                          className="px-4 py-2 text-[#404040] hover:bg-[#FBD037]/10 cursor-pointer"
                        >
                          Edit
                        </div>
                        <div
                          onClick={openShelveToggleModal}
                          className="px-4 py-2 text-[#404040] hover:bg-[#FBD037]/10 cursor-pointer"
                        >
                          Delete
                        </div>
                      </div>
                    )}
                  </div>
                ),
              },
            ]}
          />
        </div>
      </div>

      <CommonModal
        title={"Create Support Ticket"}
        open={openShelve}
        closeButtonText={"Cancel"}
        onClose={openShelveToggleModal}
        actionButtonText="Submit Ticket"
        actionButtonOnClick={openShelveToggleModal}
      >
        <CreateTicketModal />
      </CommonModal>
    </div>
  );
}
